/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_AgainInputs */

const cs_import_again = /** @type {(inputs: Import_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spustit další import`)
};

const en_import_again = /** @type {(inputs: Import_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start another import`)
};

/**
* | output |
* | --- |
* | "Start another import" |
*
* @param {Import_AgainInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_again = /** @type {((inputs?: Import_AgainInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_AgainInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_again(inputs)
	return cs_import_again(inputs)
});